import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { PraticaBase } from '../../../models/pratica/pratica-base';

declare var openModal;
declare var closeModal;
declare var getPraticaMapSync;

@Component({
    selector: '[delete-pratica]',
  template: '<span class="glyphicon glyphicon-trash"></span>Elimina pratica'
})

export class DeletePraticaComponent {
  private subscriptionDelete: Subscription;
  private pratica: PraticaBase;

  constructor(protected operationService: OperationsService, private modalNotifyService: ModalNotifyService, private router: Router, private viewManager: ViewManagerService) {
  }

  deletePratica(pratica: PraticaBase) {
    this.pratica = pratica;
    this.subscriptionDelete = this.modalNotifyService.notifyConfirmObservable.subscribe(result => this.executeDelete(result));
    this.modalNotifyService.notifyDeletePratica();
  }

  executeDelete(result: boolean) {
    if (result) {
      let praticaMap = this.getPraticaFromMap(this.pratica.tipoPratica.id);
      this.operationService.deletePratica(praticaMap.pathDelete, this.pratica.id).subscribe(response => this.praticaDeleted(response, this.pratica));
    }
    if (this.subscriptionDelete) {
      this.subscriptionDelete.unsubscribe();
    }
  }

  praticaDeleted(response, pratica: PraticaBase) {
    if (response.returnCode === 'OK') {
      console.log('eliminata pratica ' + pratica.id);
      this.viewManager._refreshAttivitaCompletare.next({param: response, timeOut: false});
      this.router.navigate(['']);
    }
  }

  private getPraticaFromMap(idTipoPraticaMap: any) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let pratica = getPraticaMapSync(idTipoPraticaMap);
    return pratica;
  }
}
